const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/externalLink.ts';
import Imm from 'immutable';
import { KisApiAction } from '@cistec/common_web/defs/actionTypes';
import { loadExternalLinks, REQUEST_ACTION_TYPES_LOAD_EXTERNAL_LINKS } from 'App/actions/externalLink';
import { getData, makeReducer2, useRemoteData2 } from '@cistec/common_web/utils/redux4Requests';
import { PatAppStoreState } from './setup/rootReducer';
import { emptyMap } from '@cistec/common_web/utils/generalUtils';

const getDataFromAction = (action: KisApiAction) => {
    const list = Imm.fromJS(action.payload.List) || emptyMap;

    const links = list
        .sortBy((entry: Imm.Map<string, any>) => Number((entry && entry.get('POS')) || 0))
        .map((entry: Imm.Map<string, any>) => {
            const de = entry.getIn(['CONTENT', 'DisplayName', 'DE']);
            const en = entry.getIn(['CONTENT', 'DisplayName', 'EN']);
            const fr = entry.getIn(['CONTENT', 'DisplayName', 'FR']);
            const it = entry.getIn(['CONTENT', 'DisplayName', 'IT']);
            const icon = entry.getIn(['CONTENT', 'Icon']);
            const url = entry.getIn(['CONTENT', 'Url']);
            const canSeeInMainNav = entry.getIn(['CONTENT', 'CanSeeInMainNav']) === '1';
            const canSeeOnDashboard = entry.getIn(['CONTENT', 'CanSeeOnDashboard']) === '1';
            return Imm.fromJS({ de, en, fr, it, icon, url, canSeeInMainNav, canSeeOnDashboard });
        })
        .toList();

    return links;
};

export const externalLinkReducer = makeReducer2([
    [REQUEST_ACTION_TYPES_LOAD_EXTERNAL_LINKS, undefined, getDataFromAction],
]);

export const selectExternalLinks = (state: PatAppStoreState) => {
    return getData(state.externalLink);
};

// HOOKS

export function useExternalLinks() {
    return useRemoteData2('externalLink', {
        request: dispatch => dispatch(loadExternalLinks()),
        select: selectExternalLinks,
    });
}
